// Finans Geçmişi'nin sağlayıcı süzgeci ve yöntem raporu (günlük mutabakat).
//
// Sağlayıcı anahtarları backend'deki `FINANCE_PROVIDER_LABELS` ile aynıdır
// (routers/admin_router.py); elle tanımlanmış banka hesaplarının kovası
// `manual`'dır ve sağlayıcısı boş ya da NULL kalmış eski kayıtları da kapsar.
import { PROVIDER_LABELS } from './financeDecision';

export const MANUAL_PROVIDER = 'manual';
export const MANUAL_PROVIDER_LABEL = 'Manuel (elle tanımlı hesap)';

const collator = new Intl.Collator('tr');

/** Süzgecin seçenekleri: önce manuel hesaplar, kalanı ada göre. */
export const FINANCE_PROVIDER_OPTIONS = [
  { id: MANUAL_PROVIDER, label: MANUAL_PROVIDER_LABEL },
  ...Object.entries(PROVIDER_LABELS)
    .map(([id, label]) => ({ id, label }))
    .sort((a, b) => collator.compare(a.label, b.label)),
];

export const financeProviderLabel = (provider) => (
  provider === MANUAL_PROVIDER
    ? MANUAL_PROVIDER_LABEL
    : PROVIDER_LABELS[provider] || provider || MANUAL_PROVIDER_LABEL);

/**
 * Rapor isteğinin parametreleri. Liste ile aynı tarih penceresini ve
 * sağlayıcıyı kullanır; tür sekmesi seçiliyse diğer yön rapordan düşer.
 * Durum süzgeci bilinçli olarak gönderilmez: mutabakatın sorusu üç durumun
 * yan yana okunmasıdır.
 */
export const buildReportParams = ({ provider, tab, dateParams }) => {
  const params = { ...dateParams };
  // Liste "Tüm zamanlar"dayken rapor da öyle okur; backend'in varsayılanı
  // bugündür ve parametre yazılmazsa liste ile rapor farklı pencere gösterirdi.
  if (!params.range) params.range = 'all';
  if (provider && provider !== 'all') params.provider = provider;
  if (tab === 'deposit' || tab === 'withdraw') params.type = tab;
  return params;
};

const num = (row, key) => Number(row?.[key] || 0);

/** Rapor satırını tablonun okuyacağı biçime çevirir. */
export const reportRowView = (row) => ({
  provider: row?.provider || MANUAL_PROVIDER,
  providerLabel: row?.provider_label || financeProviderLabel(row?.provider),
  method: row?.method || '',
  depositCount: num(row, 'deposit_onaylandi_count'),
  depositAmount: num(row, 'deposit_onaylandi_amount'),
  depositPendingCount: num(row, 'deposit_beklemede_count'),
  depositPendingAmount: num(row, 'deposit_beklemede_amount'),
  withdrawCount: num(row, 'withdraw_onaylandi_count'),
  withdrawAmount: num(row, 'withdraw_onaylandi_amount'),
  withdrawPendingCount: num(row, 'withdraw_beklemede_count'),
  withdrawPendingAmount: num(row, 'withdraw_beklemede_amount'),
  rejectedCount: num(row, 'deposit_reddedildi_count')
    + num(row, 'withdraw_reddedildi_count'),
  rejectedAmount: num(row, 'deposit_reddedildi_amount')
    + num(row, 'withdraw_reddedildi_amount'),
  net: num(row, 'net'),
});
